import './Checkbox-edc5dc3e.css';

var classes = {"Checkbox":"prc-Checkbox-Checkbox-gIwWX"};

export { classes as default };
